import React from 'react';

const OPTIONS = [
  { value: 'Bug',         label: 'Bug',  color: 'bg-red-100 text-red-700 border-red-300 hover:bg-red-200',         active: 'bg-red-500 text-white border-red-500' },
  { value: 'Test',        label: 'Test', color: 'bg-amber-100 text-amber-700 border-amber-300 hover:bg-amber-200', active: 'bg-amber-500 text-white border-amber-500' },
  { value: 'Environment', label: 'Env',  color: 'bg-blue-100 text-blue-700 border-blue-300 hover:bg-blue-200',     active: 'bg-blue-500 text-white border-blue-500' },
];

export default function RootCausePicker({ value, onChange, disabled = false, note = '', onNoteChange, onNoteBlur }) {
  if (disabled) return <span className="text-gray-300 text-xs">—</span>;

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex gap-1">
        {OPTIONS.map(opt => {
          const isActive = value === opt.value;
          return (
            <button
              key={opt.value}
              onClick={() => onChange(isActive ? null : opt.value)}
              className={`px-1.5 py-0.5 text-xs rounded border font-medium transition-colors ${isActive ? opt.active : opt.color}`}
              title={opt.value}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
      {onNoteChange && (
        <input
          type="text"
          value={note}
          onChange={e => onNoteChange(e.target.value)}
          onBlur={e => onNoteBlur && onNoteBlur(e.target.value)}
          placeholder="Note..."
          className="text-xs border border-gray-200 rounded px-1.5 py-0.5 w-full focus:outline-none focus:border-blue-400 bg-gray-50"
        />
      )}
    </div>
  );
}
